<template>
  <span class="search-tag" :class="{ 'search-tag--closable': closable }" @click="handleClick">
    <span class="search-tag__text">{{ displayText }}</span>
    <span v-if="closable" class="search-tag__close" @click.stop="handleClose">
      <icon-close />
    </span>
  </span>
</template>

<script setup>
/**
 * @description 搜索标签组件（用于热门搜索和历史记录）
 * @param {string} text - 标签文本
 * @param {boolean} closable - 是否显示关闭按钮
 * @emits click - 点击标签时触发
 * @emits close - 点击关闭按钮时触发
 */

import { computed } from 'vue'
import { IconClose } from '@arco-design/web-vue/es/icon'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  closable: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click', 'close'])

/**
 * @description 截断文本，超过20字显示省略号
 */
const displayText = computed(() => {
  if (!props.text) return ''
  const maxLength = 20
  return props.text.length > maxLength ? `${props.text.slice(0, maxLength)}...` : props.text
})

const handleClick = () => {
  emit('click')
}

const handleClose = () => {
  emit('close')
}
</script>

<style scoped lang="scss">
.search-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  height: 28px;
  border-radius: 32px; // Figma设计：32px圆角
  border: 1px solid $border-light-color; // Figma设计：边框颜色#EEEEEE
  background-color: $bg-white; // Figma设计：默认背景#FFFFFF
  color: $text-title-color; // Figma设计：文字颜色#202427
  font-size: 12px; // Figma设计：字体大小12px
  line-height: 20px; // Figma设计：lineHeight 1.6666666666666667em ≈ 20px
  font-weight: 400; // Figma设计：fontWeight 400
  cursor: pointer;
  transition: all 0.2s;

  &__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    margin-left: 6px; // Figma设计：文本与图标间距约6px
    color: $text-subtitle-color;
    transition: all 0.2s;
    flex-shrink: 0;
    border-radius: 2px;

    :deep(svg) {
      width: 12px;
      height: 12px;
    }
  }

  &:hover {
    // Figma设计：悬停时背景色变为 #F6F6F6
    background-color: $bg-muted-color;
    // 边框和文字颜色保持不变
    border-color: $border-light-color;
    color: $text-title-color;

    .search-tag__close {
      &:hover {
        color: $primary-color; // 悬停时文字变深色
      }
    }
  }

  &--closable {
    padding-right: 12px; // 有关闭按钮时保持右侧间距
  }
}
</style>
